import React from 'react';
import { Field } from 'redux-form';
import RequiredLabel from '../../RequiredLabel';
import PrivacyDropdown from '../PrivacyDropdown/PrivacyDropdown';
import ImageUploadForm from "../ImageUploadForm/ImageUploadForm";
import PrivacyRow from "../PrivacyRow/PrivacyRow";
import { Translate } from "react-localize-redux";
import InputField from '../InputField';

export const BasicProfileForm = props => (
  <React.Fragment>
    <div className="form-row">
      <div className="col-4 img-upload-form-col">
        <ImageUploadForm />
      </div>
      <div className="col-7">
        <div className="form-row">
          <label
            className="col-sm-3 offset-sm-1 col-form-label"
            htmlFor="first_name">
            <Translate id="firstnameText" />
            <br></br>
            <RequiredLabel />
          </label>
          <div className="col-7">
            <Field
              label={<Translate id="firstnameText" />}
              hideLabel={true}
              name="first_name"
              type="text"
              id="first-name-input"
              component={InputField}
            />
            
          </div>
          <div className="col-1">
            <PrivacyDropdown
              selectLabel="Privacy"
              selectName="first_name_privacy"
            />
          </div>
        </div>
        <div className="form-row">
          <label
            className="col-sm-3 offset-sm-1 col-form-label"
            htmlFor="last_name">
            <Translate id="lastnameText" />
            <br></br>
            <RequiredLabel />
          </label>
          <div className="col-7">
            <Field
              label={<Translate id="lastnameText" />}
              hideLabel={true}
              name="last_name"
              type="text"
              id="last-name-input"
              component={InputField}
            />
          </div>

          <div className="col-1">
            <PrivacyDropdown
              selectLabel="Privacy"
              selectName="last_name_privacy"
            />
          </div>
        </div>
        <div className="form-row">
          <label
            className="col-sm-3  offset-sm-1 col-form-label"
            htmlFor="occupation">
            <Translate id="Occupation" />
          </label>
          <div className="col-7">
            <Field
              label={<Translate id="Occupation" />}
              hideLabel={true}
              name="occupation"
              type="text"
              id="occupation-input"
              component={InputField}
            />
          </div>
          <div className="col-1">
            <PrivacyDropdown
              selectLabel="Privacy"
              selectName="occupation_privacy"
            />
          </div>
        </div>
        <div className="form-row">
          <label
            className="col-sm-3  offset-sm-1 col-form-label"
            htmlFor="work_place">
            <Translate id="Workplace" />
          </label>
          <div className="col-7">
            <Field
              label={<Translate id="Workplace" />}
              hideLabel={true}
              name="work_place"
              type="text"
              id="work-place-input"
              component={InputField}
            />
          </div>
          <div className="col-1">
            <PrivacyDropdown
              selectLabel="Privacy"
              selectName="work_place_privacy"
            />
          </div>
        </div>
        <div className="form-row">
          <label
            className="col-sm-3 offset-sm-1 col-form-label"
            htmlFor="prof_designations">
            <Translate id="professionalDesignations" />
          </label>
          <div className="col-7">
            <Field
              label={<Translate id="professionalDesignations" />}
              hideLabel={true}
              name="prof_designations"
              type="text"
              id="prof-des-input"
              component={InputField}
            />
          </div>
          <div className="col-1">
            <PrivacyDropdown
              selectLabel="Privacy"
              selectName="prof_des_privacy"
            />
          </div>
        </div>
      </div>
    </div>

  </React.Fragment>
);

export default BasicProfileForm;


// WEBPACK FOOTER //
// ./src/components/forms/BasicProfileForm/BasicProfileForm.jsx